import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

const MobileViewChecker = () => {
  const history = useHistory();

  useEffect(() => {
    //first load check
    if (typeof window !== 'undefined') {
      if (window.innerWidth < 1250) {
        history.push('/mobile-not-supported');
      }
    }
  }, [history]);
  return <></>;
};

export default MobileViewChecker;
